import { useQuery } from "@apollo/client";
import { notEmpty } from "@crehana/utils";
import parseCatalogCategories from "../../../Graphql/Parsers/parseCatalogCategories";
var GET_INTERESTS_PICKER_CATEGORIES = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "CatalogCategoriesQuery"
    },
    variableDefinitions: [],
    directives: [],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "catalogCategory"
        },
        arguments: [],
        directives: [],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "originalId"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "name"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "slug"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "absoluteUrl"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "courses"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "icon"
            },
            arguments: [],
            directives: []
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "subcategories"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "originalId"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "name"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "slug"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "absoluteUrl"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "courses"
                },
                arguments: [],
                directives: []
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "softwares"
            },
            arguments: [],
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "originalId"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "name"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "slug"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "absoluteUrl"
                },
                arguments: [],
                directives: []
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "courses"
                },
                arguments: [],
                directives: []
              }]
            }
          }]
        }
      }]
    }
  }],
  loc: {
    start: 0,
    end: 317,
    source: {
      body: "query CatalogCategoriesQuery {\n  catalogCategory {\n    originalId\n    name\n    slug\n    absoluteUrl\n    courses\n    icon\n    subcategories {\n      originalId\n      name\n      slug\n      absoluteUrl\n      courses\n    }\n    softwares {\n      originalId\n      name\n      slug\n      absoluteUrl\n      courses\n    }\n  }\n}\n",
      name: "GraphQL request",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  }
};
export var useInterests = function useInterests(me) {
  var _me$catalogCategoryTa, _me$catalogCategoryTa2, _me$catalogSubcategor, _me$catalogSubcategor2;
  var _useQuery = useQuery(GET_INTERESTS_PICKER_CATEGORIES),
    loading = _useQuery.loading,
    error = _useQuery.error,
    data = _useQuery.data;
  return {
    loading: loading,
    categories: data !== null && data !== void 0 && data.catalogCategory ? parseCatalogCategories(data.catalogCategory) : [],
    error: error,
    userCategories: (me === null || me === void 0 ? void 0 : (_me$catalogCategoryTa = me.catalogCategoryTastes) === null || _me$catalogCategoryTa === void 0 ? void 0 : (_me$catalogCategoryTa2 = _me$catalogCategoryTa.filter(notEmpty).map(function (_ref) {
      var originalId = _ref.originalId;
      return originalId;
    })) === null || _me$catalogCategoryTa2 === void 0 ? void 0 : _me$catalogCategoryTa2.filter(notEmpty)) || [],
    userSubCategories: (me === null || me === void 0 ? void 0 : (_me$catalogSubcategor = me.catalogSubcategoryTastes) === null || _me$catalogSubcategor === void 0 ? void 0 : (_me$catalogSubcategor2 = _me$catalogSubcategor.filter(notEmpty).map(function (_ref2) {
      var originalId = _ref2.originalId;
      return originalId;
    })) === null || _me$catalogSubcategor2 === void 0 ? void 0 : _me$catalogSubcategor2.filter(notEmpty)) || []
  };
};